import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from "./ControlPanel.module.css";

const ControlPanel = ({
	departmentSubjects,
	selectedSubject,
	setSelectedSubject,
	searchQuery,
	setSearchQuery,
	clearSearch,
}) => {
	return (
		<div className={styles.controlPanel}>
			<div className={styles.controlGroup}>
				<label htmlFor="subject-select">Subject</label>
				<select
					id="subject-select"
					className={styles.subjectDropdown}
					value={selectedSubject}
					onChange={(e) => setSelectedSubject(e.target.value)}
				>
					<option value="">All Subjects</option>
					{departmentSubjects.map((subject) => (
						<option key={subject.id} value={subject.id}>
							{subject.name}
						</option>
					))}
				</select>
			</div>

			<div className={styles.rightControls}>
				<div className={styles.controlGroup}>
					<label htmlFor="search-input">Search</label>
					<div className={styles.searchWrapper}>
						<FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
						<input
							id="search-input"
							type="text"
							className={styles.searchInput}
							placeholder="Search lectures..."
							value={searchQuery}
							onChange={(e) => setSearchQuery(e.target.value)}
						/>
						{searchQuery && (
							<button
								className={styles.clearSearch}
								onClick={clearSearch}
								title="Clear search"
							>
								<FontAwesomeIcon icon={faTimes} />
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ControlPanel;